import { useQuery } from "@tanstack/react-query";
import { AlertTriangle, Plus } from "lucide-react";
import api from "@/lib/api";
import { fmtNum } from "@/lib/format";

export function UnplannedLines({ date, plantId, sectionId, canEdit, onPlan }) {
  const q = useQuery({ queryKey: ["daily-plan-unplanned", date, plantId, sectionId], queryFn: async () => (await api.get("/daily-plan/unplanned", { params: { reporting_date: date, plant_id: plantId || undefined, section_id: sectionId || undefined } })).data, enabled: !!plantId });
  const d = q.data;
  if (!d || !d.count) return null;
  return (
    <div className="rounded-lg border border-amber-300 bg-amber-50 p-4" data-testid="unplanned-alert">
      <div className="flex flex-wrap items-center justify-between gap-2 mb-2">
        <div className="flex items-center gap-2 text-amber-900 font-semibold"><AlertTriangle size={16} /> {d.count} line(s) produced a model that is not in the Daily Plan · {fmtNum(d.actual)} pcs unplanned</div>
        <span className="text-xs text-amber-800">Line × model produced on {date} with no matching Daily Plan row — add the plan today</span>
      </div>
      <div className="flex flex-wrap gap-2">
        {d.rows.map((r) => (
          <div key={r.line_id} className="flex items-center gap-2 rounded-md border border-amber-200 bg-white px-2.5 py-1.5 text-xs" data-testid={`unplanned-${r.line_code}`}>
            <span className="font-mono font-bold text-blue-700">{r.line_code}</span>
            <span className="text-slate-500">{r.section_code}</span>
            <span className="text-slate-700">{r.models.join(", ") || "—"}</span>
            <span className="font-mono">{fmtNum(r.actual)} pcs · {r.records} row(s)</span>{r.line_planned && <span className="rounded bg-amber-100 px-1 text-[9px] font-bold uppercase text-amber-800">model not planned</span>}
            {canEdit && <button className="pp-btn-ghost h-6 px-1.5 text-blue-700" onClick={() => onPlan(r)} data-testid={`unplanned-plan-${r.line_code}`}><Plus size={12} /> Plan</button>}
          </div>
        ))}
      </div>
    </div>
  );
}
